<div
  class="psb-banner"
  *ngIf="visible"
  [class.psb-approved]="application?.status === 'approved'"
  [class.psb-rejected]="application?.status === 'rejected'"
  [class.psb-pending]="application?.status === 'pending'"
>
  <div class="psb-inner">
    <mat-icon class="psb-icon">
      {{ application?.status === 'approved' ? 'check_circle' : application?.status === 'pending' ? 'schedule' : 'info' }}
    </mat-icon>

    <span class="psb-text" *ngIf="application?.status === 'pending'">
      Your Execution Partner application is under review — we'll let you know once there's a decision.
    </span>
    <span class="psb-text" *ngIf="application?.status === 'approved'">
      You're approved as a {{ roleLabel }} — welcome aboard.
    </span>
    <span class="psb-text" *ngIf="application?.status === 'rejected'">
      There's an update on your Execution Partner application.
    </span>

    <a
      *ngIf="application?.status === 'pending'"
      routerLink="/execution-partners/applied"
      class="psb-cta"
    >
      View status
    </a>
    <a
      *ngIf="application?.status === 'approved'"
      routerLink="/execution-partners/dashboard"
      class="psb-cta"
    >
      Go to dashboard
    </a>
    <a
      *ngIf="application?.status === 'rejected'"
      routerLink="/execution-partners/applied"
      class="psb-cta"
    >
      View details
    </a>

    <button type="button" class="psb-dismiss" (click)="dismiss()" aria-label="Dismiss">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>